"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCOPE_TYPES = void 0;
/**
 * Scope-type vocabulary shared across every bounded context that resolves or
 * enforces authorization. Order and values must match
 * `docs/business-domains/authorization-model.md`'s `scopeTypeEnum` exactly.
 */
exports.SCOPE_TYPES = [
    'global',
    'tenant',
    'organization',
    'department',
    'group',
    'project',
];
//# sourceMappingURL=scope-type.js.map